package com.routexk.quiz.pages

import com.routexk.quiz.ui.utils.rpx

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.components.buttons.PrimaryButton
import com.routexk.quiz.ui.layouts.PageLayout
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.theme.AppTypography
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Page("/404")
@Composable
fun NotFoundPage() {
    PageLayout(title = "Page Not Found") {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(60.vh)
                .padding(32.rpx),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            val colorMode = ColorMode.current
            val colors = AppColors.getColors(colorMode)

            SpanText(
                "404",
                modifier = Modifier
                    .fontSize(96.rpx)
                    .fontWeight(FontWeight.Bold)
                    .color(AppColors.Primary)
                    .fontFamily(AppTypography.PRIMARY_FONT_NAME, AppTypography.PRIMARY_FONT_FALLBACK)
            )

            SpanText(
                "Page Not Found",
                modifier = Modifier
                    .fontSize(AppTypography.H4)
                    .fontWeight(FontWeight.SemiBold)
                    .color(colors.textPrimary)
                    .margin(top = 16.rpx)
            )

            SpanText(
                "The page you are looking for does not exist or has been moved.",
                modifier = Modifier
                    .fontSize(AppTypography.Body)
                    .color(colors.textSecondary)
                    .textAlign(TextAlign.Center)
                    .margin(top = 8.rpx, bottom = 32.rpx)
                    .maxWidth(400.rpx)
            )

            val ctx = rememberPageContext()
            PrimaryButton(
                text = "Go Home",
                onClick = { ctx.router.navigateTo("/") }
            )
        }
    }
}
